import { NavLink } from 'react-router-dom'

import { Tooltip } from '@percent/lemonade'

export type TitleLinkProps = Readonly<{
  campaignHref: string
  campaignTitle: string
}>

export function TitleLink({ campaignHref, campaignTitle }: TitleLinkProps) {
  if (campaignTitle.length > 70) {
    return (
      <Tooltip content={campaignTitle}>
        <NavLink style={{ color: 'rgb(var(--primary400))' }} to={campaignHref}>
          {campaignTitle.substring(0, 70)}...
        </NavLink>
      </Tooltip>
    )
  }

  return (
    <NavLink style={{ color: 'rgb(var(--primary400))' }} to={campaignHref}>
      {campaignTitle}
    </NavLink>
  )
}
